import React, { Component } from 'react'

class PromotionVariantSidePlaceholderComponent extends Component {
	render() {
        return (
			<div className="medium-12 cell promotion__variation">
				Hier hoef je niets in te stellen. De data komt uit WordPress.
			</div>
		)
    }
}

export default PromotionVariantSidePlaceholderComponent


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/variants/sideVariantPlaceholder.js